import {AbstractControl, FormControl, UntypedFormControl} from '@angular/forms';

export function CategoriesSelectTreeRequiredValidator(c: AbstractControl): boolean {
  if (!(c instanceof FormControl || c instanceof UntypedFormControl)) return true;
  if (!Array.isArray(c.value)) return true;
  return c.value.length !== 0;
}
